
if (window.location.pathname.includes("/pages/")) {
    const bss = setInterval(() => {
            const listField = document.querySelectorAll('.form-vertical .field')
       if (listField && listField.length) {
            clearInterval(bss)
          listField.forEach((item) => {
             const inputField = item.querySelector('input:not(.country-field,  #country-field)');
            const labelFiel = item.querySelector('label');
              const   a = document.querySelector('.text-center input')
             if (a) {
              a.value = 'Verzenden'
            }
            if (labelFiel && labelFiel.getAttribute('for') === 'RegisterForm-FirstName') {
              if (BSS_B2B.rfGeneralSettings.first_name) {
                 labelFiel.innerHTML = BSS_B2B.rfGeneralSettings.first_name
              }
            }
            if (labelFiel && labelFiel.getAttribute('for') === 'RegisterForm-LastName') {
              if (BSS_B2B.rfGeneralSettings.first_name) {
                 labelFiel.innerHTML = BSS_B2B.rfGeneralSettings.last_name
              }
            }
            if (labelFiel && labelFiel.getAttribute('for') === 'RegisterForm-email') {
              if (BSS_B2B.rfGeneralSettings.email) {
                 labelFiel.innerHTML = BSS_B2B.rfGeneralSettings.email
              }
            }
            if (labelFiel && labelFiel.getAttribute('for') === 'RegisterForm-password') {
              if (BSS_B2B.rfGeneralSettings.password) {
                 labelFiel.innerHTML = BSS_B2B.rfGeneralSettings.password
              }
            }
          })
    
    }

}, 100)

setTimeout(() => {
    clearInterval(bss)
}, 3000)
}

const bss = setInterval(() => {
  const listField = document.querySelector('[data-js-cart-icon]')
  if (listField) {
      listField.addEventListener("click", (e) => {
              setTimeout(() => {
                
                  const button = document.querySelector('.quick-cart__items ')
                 console.log("tét", button)
                if ( button.length) {
                   let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length) {
                           setTimeout(() => {
                             console.log("aaa")
                                BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false,
                                    false,
                                );
                            }, 1000);
                          
                        }
                    });
                });
                observer.observe(button, {childList: true});
                }
              }, 1000)
          }
        )
      clearInterval(bss)
  }

}, 1000)
setTimeout(() => {
  clearInterval(bss)
}, 4000)

